import GenericDB from './generic-db'

export default class AccountsDB extends GenericDB {
  constructor() {
    super(`accounts`)
  }

  // Here you can extend AccountsDB with custom methods
}
